// extracted by mini-css-extract-plugin
export var container = "_v-0";
export var disabled = "_v-4";
export var fullWidth = "_v-3";
export var lined = "_v-1";
export var selected = "_v-5";
export var tab = "_v-2";